<template>
  <div class="detail-page">
    <div class="detail-header clearfix">
      <detail-header-nav
        :detailNavList="detailNavList"
        :pageTab="pageTab"
        @chooseTab="getTab"
      ></detail-header-nav>
      <div class="detail-header-btn">
        <Button
          style="margin-right: 10px"
          @click="editOrder"
          v-if="
            isHavePermission('ordersBuyer:createOrupdateOrdersBuyer:updata')
          "
          >编辑
        </Button>
        <Button
          type="primary"
          icon="md-add"
          v-if="
            isHavePermission('ordersSeller:createOrUpdateOrdersSeller:0:add')
          "
          @click="createOrder"
          >新建承运人订单
        </Button>
        <Dropdown
          style="margin-left: 10px"
          v-if="
            isHavePermission('invoice:createInvoiceSeller') ||
            isHavePermission('payments:createPaymentsBuyer') ||
            isHavePermission('logistics:createLogistics') ||
            isHavePermission('receiving:createBuyerReceiveGoods:add')
          "
        >
          <Button>
            更多操作
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              v-if="isHavePermission('logistics:createLogistics')"
              @click.native="showLogisticsModal"
              >新建物流信息
            </DropdownItem>
            <DropdownItem
              v-if="isHavePermission('receiving:createBuyerReceiveGoods:add')"
              @click.native="showReceivingModal"
              >新建结算信息
            </DropdownItem>
            <DropdownItem
              v-if="isHavePermission('payments:createPaymentsBuyer') || isHavePermission('payments:createPaymentsBuyerOnline')"
              @click.native="ShowCreatePaymentModal"
              >款项收入流程
            </DropdownItem>
            <!-- <DropdownItem
               v-if="isHavePermission('payments:createPaymentsSeller')"
              @click.native="ShowCreateNewPaymentModal"
              >费用支出流程
            </DropdownItem> -->
            <DropdownItem
              v-if="isHavePermission('invoice:createInvoiceSeller')"
              @click.native="ShowCreateInvoiceModal"
              >开票申请流程
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button icon="md-refresh" @click="freshen" style="margin-left: 10px"
          >刷新
        </Button>
      </div>
    </div>
    <div v-show="pageTab === 'tab1'">
      <detail-title
        :title="conBoxTitle1.title"
        :info="conBoxTitle1.info"
      ></detail-title>
      <buyer-order-info
        :orderInfo="orderInfo"
        :imageData="imageData"
        @update="getDetailInfo"
      ></buyer-order-info>
      <detail-title :title="conBoxTitle2.title"></detail-title>
      <order-list :id="id" @update="getDetailInfo"></order-list>
      <detail-title :title="conBoxTitle3.title"></detail-title>
      <detail-time-line :timeLineList="timeLineList"></detail-time-line>
    </div>
    <div v-show="pageTab === 'tab2'">
      <buyer-order-logistics
        :id="id"
        :pageTab="pageTab"
        ref="logisticsList"
      ></buyer-order-logistics>
    </div>
    <div v-show="pageTab === 'tab3'">
      <buyer-order-receiving
        :id="id"
        :pageTab="pageTab"
        ref="receivingList"
      ></buyer-order-receiving>
    </div>
    <div v-show="pageTab === 'tab4'">
      <buyer-order-collection
        :id="id"
        :pageTab="pageTab"
        :chainId="chainId"
        ref="paymentList"
      ></buyer-order-collection>
    </div>
    <div v-show="pageTab === 'tab5'">
      <buyer-order-invoice
        :id="id"
        :pageTab="pageTab"
        ref="invoiceList"
      ></buyer-order-invoice>
    </div>
    <vxe-modal
      v-model="isShowAddModal"
      :title="modalTitle"
      width="1300"
      height="660"
      resize
      position="center"
    >
      <create-seller-order
        :isShowAddModal="isShowAddModal"
        :type="openType"
        :rowInfo="rowInfo"
        @closeModal="getCloseModalVal"
      ></create-seller-order>
    </vxe-modal>
    <vxe-modal
      v-model="logisticsVisible"
      title="新建物流信息"
      width="1300"
      height="660"
      @close="closeLogisticsModal"
      resize
      position="center"
    >
      <create-logistics-modal
        ref="logisticsModal"
        @afterSave="closeLogisticsCreate"
        :orderId="orderInfo.chainId"
      ></create-logistics-modal>
    </vxe-modal>
    <vxe-modal
      v-model="receivingVisible"
      title="新建结算信息"
      width="1300"
      top="150"
      @close="closeCreate"
      height="660"
      resize
      position="center"
    >
      <create-receiving-model
        ref="receivingModal"
        @createCommit="createCommit"
        v-bind:orderType="orderType"
        v-bind:isIncludedTax="isIncludedTax"
      ></create-receiving-model>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCreatePayment"
      title="款项收入流程"
      width="1300"
      height="760"
      position="center"
      resize
    >
      <create-collection
        :cate="'Collection'"
        :isShow="isShowCreatePayment"
        ref="createPaymentModal"
        @close="isShowCreatePayment = false"
        @init="init"
      ></create-collection>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCreateInvoice"
      title="开票申请流程"
      width="1300"
      height="660"
      resize
      position="center"
    >
      <create-invoice
        :cate="'Sales'"
        :isShow="isShowCreateInvoice"
        ref="createInvoice"
        @close="isShowCreateInvoice = false"
        @init="init"
      ></create-invoice>
    </vxe-modal>
    <vxe-modal
      v-model="isShowNewCreatePayment"
      title="费用支出流程"
      width="1300"
      height="760"
      position="center"
      resize
    >
      <create-new-payment
        :chainId="chainId"
        :cate="'Payment'"
        :isShow="isShowNewCreatePayment"
        ref="createNewPaymentModal"
        @close="isShowNewCreatePayment = false"
        @init="init"
      ></create-new-payment>
    </vxe-modal>
    <vxe-modal
      v-model="isShowUpdateModal"
      title="编辑托运人订单"
      width="1300"
      height="660"
      position="center"
      resize
    >
      <create-order-model
        ref="createOrder"
        :isShowAddModal="isShowUpdateModal"
        :type="updateType"
        :rowInfo="updateInfo"
        @closeModal="getClose"
      ></create-order-model>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import DetailHeaderNav from "@/components/common/DetailHeaderNav"; // 详情页顶部导航组件
import DetailTitle from "@/components/common/DetailTitle"; // 标题组件
import DetailTimeLine from "@/components/common/DetailTimeLine"; // 时间轴组件
import OrderList from "@/components/order/buyer/OrderList"; // 关联承运人订单
import BuyerOrderInfo from "@/components/order/buyer/BuyerOrderInfo"; // 关联承运人订单
import BuyerOrderLogistics from "@/components/order/buyer/BuyerOrderLogistics"; // 物流信息
import BuyerOrderReceiving from "@/components/order/buyer/BuyerOrderReceiving"; // 结算信息
import BuyerOrderCollection from "@/components/order/buyer/BuyerOrderCollection"; // 收款信息
import BuyerOrderInvoice from "@/components/order/buyer/BuyerOrderInvoice"; // 进项发票
import CreateSellerOrder from "@/components/order/CreateSellerOrder"; // 创建新订单
import CreateOrderModel from "@/components/order/CreateOrderModel"; // 创建新订单
import CreateLogisticsModal from "@/views/logistics/CreateModal";
import CreateReceivingModel from "@/views/receiving/CreateReceivingModel"; // 创建结算信息
import CreateInvoice from "@/views/invoice/CreateInvoice.vue";
import CreateNewPayment from "@/components/modal/PayOrder.vue";
  import {
    getExcelTime,
    paymentFooter,
    showLoading,
    hideLoading,
    showFailMsgList,
    isEmpty,
    isNotEmpty,
  } from "@/utils/util";

import { timeFormatDate } from "@/filters/time";
import getAuthOrization from "@/mixin/getAuthOrization";
import CreateCollection from "@/views/payment/CreateCollection.vue";

export default {
  components: {
    DetailHeaderNav,
    DetailTitle,
    DetailTimeLine,
    OrderList,
    BuyerOrderInfo,
    BuyerOrderLogistics,
    BuyerOrderReceiving,
    BuyerOrderCollection,
    BuyerOrderInvoice,
    CreateSellerOrder,
    CreateOrderModel,
    CreateLogisticsModal,
    CreateReceivingModel,
    CreateInvoice,
    CreateCollection,
    CreateNewPayment,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      id: this.$route.params.id, // 主键ID
      detailNavList: [
        {
          title: "基础信息",
          tab: "tab1",
        },
        {
          title: "物流信息",
          tab: "tab2",
        },
        {
          title: "结算信息",
          tab: "tab3",
        },
        {
          title: "应收账款",
          tab: "tab4",
        },
        {
          title: "销项发票",
          tab: "tab5",
        },
      ],
      pageTab: "tab1", // 显示选项
      conBoxTitle1: {
        title: "订单内容",
        info: "",
      },
      conBoxTitle2: {
        title: "关联承运人订单",
      },
      conBoxTitle3: {
        title: "订单执行动态",
      },
      orderList: [], // 关联承运人订单
      orderInfo: {}, // 订单内容
      timeLineList: {},
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      imageData: [],
      logType: 1, // 0 供应链相关日志 1 托运人相关日志 承运人相关日志
      ordersNum: null,
      isShowAddModal: false,
      openType: 2,
      modalTitle: "新建承运人订单",
      rowInfo: null,
      aboutOrder: {
        orderId: null,
        orderNum: null,
        rule: null,
        price: null,
        goodsName: null,
        unit: null,
      },
      logisticsVisible: false,
      receivingVisible: false,

      isShowCreatePayment: false, //创建收付款弹窗
      isShowCreateInvoice: false, //创建发票弹窗
      isShowNewCreatePayment: false,

      orderType: 1,
      isIncludedTax: "托运人货物交接确认",
      chainId: null,
      isShowUpdateModal: false,
      updateType: 0,
      updateInfo: {},
    };
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
      if (to.name === "托运人订单详情") {
        this.pageTab = "tab1";
        this.imageData = [];
        this.init();
      }
    },
  },
  created() {
    this.pageTab = "tab1";
    this.init();
  },
  methods: {
    editOrder() {
      this.getDetailInfo();
      this.updateType = 1;
      this.isShowUpdateModal = !this.isShowUpdateModal;
      // this.$refs.createOrder.init();
      this.$refs.createOrder.$refs.saleHeader.init();
      this.$refs.createOrder.$refs.saleHeader.setSaleData(
        this.orderInfo.salesManName,
        this.orderInfo.salesManagerName
      );
      // console.log(row, 'row')
    },
    getClose(val) {
      this.isShowUpdateModal = val;
      this.getDetailInfo();
      this.$bus.$emit("isGetAboutOrder", true);
      // this.getOrderList();
    },
    init() {
      this.getDetailInfo();
      // this.getAboutOrder();
      this.getTimeLine();
      this.$bus.$emit("orderDetailRenovate", true);
      this.$bus.$emit("isGetAboutOrder", true);
      // if (this.$refs.paymentList != undefined) {
      //   this.$refs.paymentList.init();
      // }
      // if (this.$refs.invoiceList != undefined) {
      //   this.$refs.invoiceList.init();
      // }
    },
    freshen() {
      switch (this.pageTab) {
        case "tab1":
          this.init();
          break;
        case "tab2":
          //物流
          this.$refs.logisticsList.getLogisticsListData();
          break;
        case "tab3":
          //结算
          this.$refs.receivingList.getReceivingListData();
          break;
        case "tab4":
          this.$refs.paymentList.init();
          break;
        case "tab5":
          this.$refs.invoiceList.init();
          break;
      }
    },
    createOrder() {
      this.openType = 2;

      this.rowInfo = {
        chainId: this.orderInfo.chainId,
        chainNum: this.orderInfo.chainNum,
        buyerOrdersNum: this.orderInfo.buyerOrdersNum,
      };
      this.isShowAddModal = !this.isShowAddModal;
    },
    getCloseModalVal(val) {
      this.isShowAddModal = val;
      this.getDetailInfo();
      this.$bus.$emit("isGetAboutOrder", true);
      // this.getAboutOrder();
    },
    getTab(val) {
      this.pageTab = val;
    },
    getDetailInfo() {
      showLoading()
      $api.order.queryOrdersBuyerDetailModel
        .POST({
          data: {
            id: parseInt(this.id),
          },
        })
        .then((res) => {
          if (res.status === 1) {
            hideLoading()
            this.orderInfo = res.data;
            this.updateInfo = JSON.parse(JSON.stringify(res.data));
            this.chainId = this.orderInfo.chainId;
            // console.log(this.orderInfo, 'this.orderInfo');
            this.aboutOrder.orderId = res.data.id;
            this.aboutOrder.orderNum = res.data.buyerOrdersNum;
            this.aboutOrder.platformCompany = res.data.platformCompany;
            if (res.data.goodsRtnVos.length > 0) {
              this.aboutOrder.unit = res.data.goodsRtnVos[0].unit;
              this.aboutOrder.goodsName = res.data.goodsRtnVos[0].goodsName;
              this.aboutOrder.price = res.data.goodsRtnVos[0].price;
              this.aboutOrder.rule = res.data.goodsRtnVos[0].rule;
            }
            let salesManNameTxt = res.data.salesManName
              ? ` | 业务员：${res.data.salesManName}`
              : "";
            let salesManagerNameTxt = res.data.salesManagerName
              ? ` | 销售经理：${res.data.salesManagerName}`
              : "";

            if (this.isHavePermission("global:viewCreateTime")) {
              this.conBoxTitle1.info = `子订单编号：${
                res.data.buyerOrdersNum
              }${salesManNameTxt}${salesManagerNameTxt} | 客户经理：${
                res.data.createUser
              } | 创建日期：${timeFormatDate(res.data.createTime)}`;
            } else {
              this.conBoxTitle1.info = `子订单编号：${res.data.buyerOrdersNum}${salesManNameTxt}${salesManagerNameTxt} | 客户经理：${res.data.createUser}`;
            }

            this.ordersNum = res.data.buyerOrdersNum;
            this.imageData = [];
            if (res.data.orderPicUrl && res.data.orderPicUrl.length > 0) {
              let arrData = res.data.orderPicUrl;
              arrData.map((v) => {
                v.name = v.oldName;
              });
              this.imageData = arrData;
            }
          } else {
            hideLoading()
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        });
    },
    // getAboutOrder() {
    //   // queryOrdersSellerListModel
    //   $api.order.queryOrdersSellerListModel
    //     .POST({
    //       data: {
    //         buyerOrdersId: this.id,
    //         isSecondSeller: 0,
    //         page: this.page.currentPage,
    //         rows: this.page.pageSize,
    //       },
    //     })
    //     .then((res) => {
    //       if (res.status === 1) {
    //         this.orderList = res.data.rows;
    //       } else {
    //         this.$XModal.alert({
    //           message: res.message ? res.message : "接口异常",
    //           status: "error",
    //         });
    //       }
    //     });
    // },
    getTimeLine() {
      $api.order.queryOrderLogListModel
        .POST({
          data: {
            orderId: this.id,
            logType: this.logType, //
          },
        })
        .then((res) => {
          if (res.status === 1) {
            this.timeLineList = res.data;
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        });
    },
    showLogisticsModal() {
      this.logisticsVisible = true;
      this.$refs.logisticsModal.setExport(false);
      // this.$refs.logisticsModal.setRelationOrder(this.aboutOrder.orderNum, this.aboutOrder.orderId);
    },
    closeLogisticsModal() {
      this.$refs.logisticsModal.close();
      this.logisticsVisible = false;
    },
    closeLogisticsCreate() {
      this.logisticsVisible = false;
      this.$refs.logisticsList.getLogisticsListData();
    },
    showReceivingModal() {
      this.receivingVisible = true;
      this.$refs.receivingModal.setRelationOrder(this.aboutOrder, "1");
    },
    closeCreate() {
      this.$refs.receivingModal.clearTableV();
      this.$refs.receivingModal.reCommit();
    },
    ShowCreatePaymentModal() {
      this.isShowCreatePayment = true;
      this.$refs.createPaymentModal.initByOrderInfo(this.orderInfo);
    },
    ShowCreateInvoiceModal() {
      this.isShowCreateInvoice = true;
      this.$refs.createInvoice.initByOrderInfo(this.orderInfo);
    },
    ShowCreateNewPaymentModal() {
      this.isShowNewCreatePayment = true;
      this.$refs.createNewPaymentModal.initByOrderInfo(this.orderInfo, 1);
    },
    createCommit() {
      this.receivingVisible = false;
      this.$refs.receivingList.getReceivingListData();
    },
  },
};
</script>

<style>
</style>